var map = {
	"./en.json": 96082,
	"./en/account.php": 64487,
	"./en/artifact-isle.php": 27192,
	"./en/auth.php": 7900,
	"./en/blog.php": 5258,
	"./en/bundle.php": 81766,
	"./en/checkout.php": 29618,
	"./en/detention.php": 58202,
	"./en/docs.php": 37735,
	"./en/echoes-of-the-asylum.php": 35705,
	"./en/expedition-northpole.php": 52327,
	"./en/game.php": 81288,
	"./en/general.php": 35182,
	"./en/merlins-castle.php": 1671,
	"./en/murder-in-the-alley.php": 47467,
	"./en/pagination.php": 90710,
	"./en/passwords.php": 46652,
	"./en/rooms.php": 17110,
	"./en/routes.php": 26696,
	"./en/the-saloon.php": 97972,
	"./en/underground-murder.php": 33531,
	"./en/validation.php": 12035,
	"./en/wordle.php": 34251,
	"./nl.json": 88771,
	"./nl/account.php": 57500,
	"./nl/artifact-isle.php": 65827,
	"./nl/auth.php": 62725,
	"./nl/bundle.php": 85051,
	"./nl/checkout.php": 25647,
	"./nl/detention.php": 47569,
	"./nl/docs.php": 43138,
	"./nl/echoes-of-the-asylum.php": 99948,
	"./nl/expedition-northpole.php": 98690,
	"./nl/game.php": 3745,
	"./nl/general.php": 48161,
	"./nl/merlins-castle.php": 34990,
	"./nl/murder-in-the-alley.php": 74656,
	"./nl/pagination.php": 97087,
	"./nl/passwords.php": 11843,
	"./nl/rooms.php": 88413,
	"./nl/routes.php": 8001,
	"./nl/the-saloon.php": 60693,
	"./nl/underground-murder.php": 88634,
	"./nl/validation-inline.php": 42480,
	"./nl/validation.php": 76170
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29945;